import React from "react";
import { TableHeaderProps } from "react-virtualized";
import Flex from "../Flex/Flex";
import Text from "../Text/Text";
import { LineArrowIcon } from "../icons";

export const SortableHeader: React.FunctionComponent<TableHeaderProps> = ({
  dataKey,
  label,
  sortBy,
  sortDirection,
  ...restProps
}) => {
  const showSortIndicator = sortBy === dataKey;

  return (
    <Flex align="flex-end" {...restProps}>
      <Text
        className="ReactVirtualized__Table__headerTruncatedText"
        title={typeof label === "string" ? label : undefined}
      >
        {label}
      </Text>
      {showSortIndicator && (
        <LineArrowIcon
          direction={sortDirection === "ASC" ? "up" : "down"}
          size="14px"
          ml={1}
          sx={{ color: "red" }}
        />
      )}
    </Flex>
  );
};
